<template>
  <el-container style="position: relative;">
    <el-aside width="300px">
      <el-card class="base-card" shadow="never" :body-style="{ padding: '0px' }">
        <div slot="header" class="base-card-header">
          <span>标签信息</span>
        </div>
        <el-scrollbar :style="{height: (getMainContextHeight - 94) + 'px'}" class="custom-scroll">
          <el-tree ref="featureLeftTree" :props="{label: 'name'}"
            :data="featurePage.featureLeftTree.impl.dropdownList"
            node-key="id" @node-click="onFeatureLeftTreeValueChange"
            :highlight-current="true" :default-expand-all="true" />
        </el-scrollbar>
      </el-card>
    </el-aside>
    <el-main style="padding-left: 15px;">
      <el-scrollbar :style="{height: (getMainContextHeight - 42) + 'px'}" class="custom-scroll">
        <el-form ref="featurePageFilter" :model="featurePage" :size="defaultFormItemSize"
          label-width="100px" label-position="right" @submit.native.prevent
        >
          <filter-box :item-width="350">
            <el-form-item label="标签名称" prop="formFilter.featureName">
              <el-input class="filter-item" v-model="featurePage.formFilter.featureName"
                :clearable="true" placeholder=""
              />
            </el-form-item>
            <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetFeaturePage">重置</el-button>
            <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshFeaturePage(true)">查询</el-button>
            <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('featurePage:featurePage:featureEditAdd')"
              @click="onFeatureEditAddClick()">
              新增
            </el-button>
          </filter-box>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-table ref="sysFeature" :data="featurePage.SysFeature.impl.dataList" :size="defaultFormItemSize" @sort-change="featurePage.SysFeature.impl.onSortChange"
              header-cell-class-name="table-header-gray"
              highlight-current-row @current-change="featurePage.SysFeature.impl.currentRowChange"
            >
              <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="featurePage.SysFeature.impl.getTableIndex" />
              <el-table-column label="标签名称" prop="featureName">
              </el-table-column>
              <el-table-column label="父级" prop="parentIdDictMap.name">
              </el-table-column>
              <el-table-column label="显示顺序" prop="showOrder">
              </el-table-column>
              <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                  <el-button @click.stop="onFeatureEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                    :disabled="!checkPermCodeExist('featurePage:featurePage:featureEdit')">
                    编辑
                  </el-button>
                  <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                    :disabled="!checkPermCodeExist('featurePage:featurePage:delete')">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex" justify="end" style="margin-top: 10px;">
              <el-pagination
                :total="featurePage.SysFeature.impl.totalCount"
                :current-page="featurePage.SysFeature.impl.currentPage"
                :page-size="featurePage.SysFeature.impl.pageSize"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, prev, pager, next, sizes"
                @current-change="featurePage.SysFeature.impl.onCurrentPageChange"
                @size-change="featurePage.SysFeature.impl.onPageSizeChange">
              </el-pagination>
            </el-row>
          </el-col>
        </el-row>
      </el-scrollbar>
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysFeatureController, DictionaryController } from '@/api';
import featureEdit from '@/views/baseInfo/featureEdit.vue';

export default {
  name: 'featurePage',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      featurePage: {
        formFilter: {
          featureLeftTree: undefined,
          featureName: undefined
        },
        formFilterCopy: {
          featureLeftTree: undefined,
          featureName: undefined
        },
        featureLeftTree: {
          impl: new DropdownWidget(this.loadFeatureLeftTreeDropdownList, true, 'id', 'parentId')
        },
        SysFeature: {
          impl: new TableWidget(this.loadSysFeatureWidgetData, this.loadSysFeatureVerify, true, true, 'showOrder', 1)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetFeaturePage () {
      this.$refs.featurePageFilter.resetFields();
      this.refreshFeaturePage(true);
    },
    /**
     * 系统标签词表数据获取函数，返回Promise
     */
    loadSysFeatureWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        sysFeatureDtoFilter: {
          parentId: this.featurePage.formFilterCopy.featureLeftTree,
          featureName: this.featurePage.formFilterCopy.featureName
        }
      }
      return new Promise((resolve, reject) => {
        SysFeatureController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.featurePage.SysFeature.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.featurePage.SysFeature.impl.currentRow.id, 'id');
              this.$refs.sysFeature.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 系统标签词表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysFeatureVerify () {
      this.featurePage.formFilterCopy.featureLeftTree = this.featurePage.formFilter.featureLeftTree;
      this.featurePage.formFilterCopy.featureName = this.featurePage.formFilter.featureName;
      return true;
    },
    /**
     * 标签信息下拉数据获取函数
     */
    loadFeatureLeftTreeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictFeatureDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 标签信息选中值改变
     */
    onFeatureLeftTreeValueChange (value) {
      if (value.id !== this.featurePage.formFilter.featureLeftTree) {
        this.featurePage.formFilter.featureLeftTree = value.id;
      } else {
        this.featurePage.formFilter.featureLeftTree = undefined;
        this.$nextTick(() => {
          this.$refs.featureLeftTree.setCurrentKey(null);
        });
      }
      this.refreshFeaturePage(true);
    },
    /**
     * 更新标签管理
     */
    refreshFeaturePage (reloadData = false) {
      if (reloadData) {
        this.featurePage.SysFeature.impl.refreshTable(true, 1);
      } else {
        this.featurePage.SysFeature.impl.refreshTable();
      }
      if (!this.featurePage.isInit) {
        // 初始化下拉数据
        this.featurePage.featureLeftTree.impl.onVisibleChange(true);
      }
      this.featurePage.isInit = true;
    },
    /**
     * 新增
     */
    onFeatureEditAddClick () {
      let params = {};

      this.$dialog.show('新增', featureEdit, {
        area: '500px'
      }, params).then(res => {
        this.refreshFeaturePage();
        this.featurePage.featureLeftTree.impl.reloadDropdownData(true).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onFeatureEditClick (row) {
      let params = {
        id: row.id
      };

      this.$dialog.show('编辑', featureEdit, {
        area: '500px'
      }, params).then(res => {
        // this.featurePage.SysFeature.impl.refreshTable();
        this.refreshFeaturePage();
        this.featurePage.featureLeftTree.impl.reloadDropdownData(true).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      SysFeatureController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.featurePage.SysFeature.impl.refreshTable(false, 1);
        this.featurePage.featureLeftTree.impl.reloadDropdownData(true).catch(e => {});
      }).catch(e => {});
    },
    onResume () {
      this.refreshFeaturePage();
    },
    initFormData () {
    },
    formInit () {
      this.refreshFeaturePage();
    }
  },
  computed: {
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>

<style scoped>
  >>> .el-tree-node__content {
    height: 35px;
  }
</style>
